import { Component, ViewChild, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from 'shared/config/env.config';

import { ProfilePasswordFormComponent } from 'shared/profile/profile-password-form/profile-password-form.component';

// uncomment when add methods
import { ForgotPasswordService } from './forgot-password.service';


/**
 *    This class represents the lazy loaded WelcomeComponent.
 */

@Component({
  moduleId: module.id,
  selector: 'forgot-password-cmp',
  templateUrl: 'forgot-password.component.html',
  styleUrls: ['forgot-password.component.scss'],
  // providers: [ProfileInfoService],
})
export class ForgotPasswordComponent implements OnInit {

  @ViewChild('profileForm', {static: false}) profileForm: ProfilePasswordFormComponent | void;
  isSent: boolean = false;
  form: UntypedFormGroup;
  emailInvalid: boolean = false;

  constructor(
    // private profileInfoService: ProfileInfoService,
    protected router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private forgotPasswordService: ForgotPasswordService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      'email': [null, Validators.compose([Validators.required, Validators.email])],
    });
  }

  // handlers
  onSubmitClick() {
    if (!this.form || this.form.invalid) { return; }
    this.emailInvalid = false;
    const value = this.form.value;

    this.forgotPasswordService.send(this.form.controls['email'].value )
      .subscribe( (res) => {
        if (res.success) {
          this.isSent = true;
        } else {
          this.emailInvalid = true;
        }
      },
      (err) => {
          this.emailInvalid = true;
      });
  }

  onLoginClick() {
    this.router.navigate(['/login']);
  }
}
